import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = {
    key: 1,
    class: "alert alert--error"
};
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import venso from "@/services/VensoRepository";
import VensoOrderGroup from "@/components/VensoOrderGroup.vue";
import { updateDeliveryNoticeItem } from "@/commands/UpdateDeliveryNoticeItem";
import { addDeliveryNoticeItem } from "@/commands/AddDeliveryNoticeItem";
import { saveDeliveryNoticeComment } from "@/commands/SaveDeliveryNoticeComment";
import { removeDeliveryNoticeItem } from "@/commands/RemoveDeliveryNoticeItem";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoOrderGroupView',
    setup(__props) {
        const route = useRoute();
        const groupId = ref(Number(route.params.id));
        const accessToken = ref(route.query.token);
        const group = ref(null);
        const taxRates = ref([]);
        const error = ref(null);
        onMounted(loadOrderGroup);
        onMounted(loadTaxRates);
        watch(groupId, loadOrderGroup);
        function loadOrderGroup() {
            venso.getOrderGroup(groupId.value, accessToken.value)
                .then(data => group.value = data)
                .catch(e => error.value = e || 'error');
        }
        function loadTaxRates() {
            venso.getTaxRates(groupId.value, accessToken.value)
                .then(data => taxRates.value = data)
                .catch(() => taxRates.value = []);
        }
        function onDeliveryNoticeItemUpdate(update) {
            if (!group.value) {
                throw new Error('Group not loaded yet');
            }
            updateDeliveryNoticeItem(group.value.id, group.value.accessCode, update)
                .then(() => {
                loadOrderGroup();
            });
        }
        function onDeliveryNoticeItemAdd(item) {
            if (!group.value) {
                throw new Error('Group not loaded yet');
            }
            addDeliveryNoticeItem(group.value.id, group.value.accessCode, item)
                .then(() => {
                loadOrderGroup();
            });
        }
        function onDeliveryNoticeItemRemove(itemRef) {
            if (!group.value) {
                throw new Error('Group not loaded yet');
            }
            removeDeliveryNoticeItem(group.value.id, group.value.accessCode, itemRef)
                .then(loadOrderGroup);
        }
        function onDeliveryNoticeSaveComment(orderId, comment) {
            if (!group.value) {
                throw new Error('Group not loaded yet');
            }
            saveDeliveryNoticeComment(group.value.id, group.value.accessCode, orderId, comment);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !group.value && !error.value
                }, null, 8, ["loading"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (group.value)
                    ? (_openBlock(), _createBlock(VensoOrderGroup, {
                        key: 0,
                        group: group.value,
                        "tax-rates": taxRates.value,
                        onItemQuantityUpdate: onDeliveryNoticeItemUpdate,
                        onAddNoticeItem: onDeliveryNoticeItemAdd,
                        onRemoveNoticeItem: onDeliveryNoticeItemRemove,
                        onSaveNoticeComment: onDeliveryNoticeSaveComment,
                        onConfirmed: loadOrderGroup
                    }, null, 8, ["group", "tax-rates"]))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('venso_order_group.load_error', { error: error.value })), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
